const TITLES = {
  "all-results": "All Results",
  maternity: "Maternity",
  "outstanding-lab-tests": "Outstanding Laboratory Tests",
  laboratory: "Laboratory",
  radiology: "Radiology",
  appointment: "Appointment",
  "referral-responses": "Referral responses",
  "coop-discharges": "COOP / Discharges",
  "postal-correspondence": "Postal correspondence",
  other: "Other",
};

export const selectedItemToTitle = (selectedItem) =>
  TITLES[selectedItem] ?? "All Results";
